import React from "react";
import styled from "styled-components";
import { PoolsTableRowMobile } from "./PoolsTableRowMobile";
import { tokenMap } from "@/placeholders/tokens";
import { formatDisplay, formatDisplayShorthand } from "@/utils/formatDisplay";

interface LBPTableMobileProps {
  data: Array<object>;
  activeView: string;
}

export const PoolsTableMobile = ({ data, activeView }: LBPTableMobileProps) => {
  return (
    <LBPTableContainerStyled>
      {data
        ? data?.map(({ name, subname, liquidity, volume, apy, status, marketCap }: any) => {
            const data: {
              icon: string;
              name: string;
              subname: string;
              info?: { title: string; value: string; color?: string }[];
            } = {
              icon: tokenMap[name]?.icon,
              name: name,
              subname: subname,
            };
            if (activeView === "LP Tokens")
              data.info = [
                {
                    title: "APY",
                    value: `${apy > 1 ? formatDisplay(((apy - 1) * 100).toString(), 2) : '--'}%`,
                    color: '#7ADEB9'
                },
                {
                  title: "Liquidity",
                  value: `$${formatDisplayShorthand(liquidity ?? 0)}`,
                },
                {
                  title: "24h Vol",
                  value: `$${formatDisplayShorthand(volume ?? 0)}`,
                },
              ];
            else 
              data.info = [
                {
                    title: "Status",
                    value: status,
                },
                {
                  title: "Market Cap",
                  value: `$${formatDisplayShorthand(marketCap ?? 0)}`,
                },
                {
                  title: "Volume",
                  value: `$${formatDisplayShorthand(volume ?? 0)}`,
                },
              ];
            return <PoolsTableRowMobile {...data} key={name + subname} />;
          })
        : null}
    </LBPTableContainerStyled>
  );
};

const LBPTableContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
